// Zeugenblock in Schritt 6 des Übergabe-Assistenten (SchrittUnterschriften.tsx) —
// beliebig viele Zeugen-Karten plus „Zeuge hinzufügen". Als eigene Komponente
// ausgelagert, damit die Kartenliste nicht mit der Signier-Logik verwächst: die
// eigentliche Karte (Name/Ort/Datum, Unterschreiben, Anzeige der Signatur) bleibt in
// SchrittUnterschriften.tsx, dieselbe wie bei Übergeber/Übernehmer — hier hereingereicht
// über `renderKarte`, damit es nur EINE Kartendarstellung im ganzen Schritt gibt.
//
// Bekommt alles per Props, keine eigene Datenbeschaffung (kein useState, kein Zugriff
// auf entwurf/setEntwurf) — die Signier-Logik bleibt vollständig in der aufrufenden
// Komponente.
import React from 'react';
import { Trash, UserPlus } from '@phosphor-icons/react';
import type { Partei } from '../../../lib/uebergabe/typen';
import { parteiLabel } from '../../../lib/uebergabe/unterschriften';

interface ZeugenKartenProps {
  zeugen: Partei[];
  alleParteien: Partei[];
  /** Zweites Argument: Fußzeile in der Karte (hier „Zeuge n entfernen“) */
  renderKarte: (partei: Partei, fuss?: React.ReactNode) => React.ReactNode;
  /** Rasterstil wie bei Übergeber/Übernehmer */
  raster: React.CSSProperties;
  /** Touch: Tippfläche 44 px */
  touch: boolean;
  onHinzufuegen: () => void;
  onEntfernen: (partei: Partei) => void;
}

const ZeugenKarten: React.FC<ZeugenKartenProps> = ({ zeugen, alleParteien, renderKarte, raster, touch, onHinzufuegen, onEntfernen }) => {
  return (
    <>
      {zeugen.length > 0 && (
        <div style={raster}>
          {zeugen.map(partei => {
            const label = parteiLabel(partei, alleParteien);
            // Entfernen nur bei Zeugen — Übergeber/Übernehmer (dieselbe Karte) sind nicht entfernbar.
            const fuss = (
              <button type="button" onClick={() => onEntfernen(partei)} className="inline-flex items-center self-start"
                data-tip={`${label} entfernen – Zeugen sind freiwillig`}
                style={{ height: touch ? 44 : 32, padding: '0 10px', gap: 5, borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                  fontSize: 12, fontWeight: 700, background: 'transparent', color: 'var(--bad)' }}>
                <Trash size={12} weight="bold" />{label} entfernen
              </button>
            );
            return <React.Fragment key={partei.pid ?? partei.rolle}>{renderKarte(partei, fuss)}</React.Fragment>;
          })}
        </div>
      )}
      {/* Zurückhaltend als Pille — keine Pflichthandlung wie „Unterschreiben", sondern ein optionales Extra. */}
      <button type="button" onClick={onHinzufuegen} data-tip="Zeuge hinzufügen – Zeugen sind freiwillig" className="inline-flex items-center self-start"
        style={{ height: touch ? 44 : 42, padding: '0 16px', gap: 7, borderRadius: 22, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
          fontSize: 13, fontWeight: 800, background: 'var(--glass)', boxShadow: 'var(--glass-sh)', color: 'var(--acc)' }}>
        <UserPlus size={15} weight="bold" />Zeuge hinzufügen
      </button>
    </>
  );
};

export default ZeugenKarten;
